import { OktaIntegrationType } from '@glueapp/graph-types';

export const OktaIntegration: OktaIntegrationType = {
    integrationType: 'okta',
    provider: 'okta',
    renderOptionLabel(metaData) {
        return metaData.oktaDomain.replace('https://', '');
    },
    allowedDomains: ['okta.com'],
};
